<template>
    <div class="d-flex align-center" style="min-width:290px; width:290px;">
      <v-spacer></v-spacer>
          <span class="mr-1">
            <svg height="30" width="25" v-for="index in 10" :key="index">
              <circle cx="10" cy="17" r="9"
                      :stroke="colors[index]"
                      stroke-width="1.3"
                      :fill="getFill(score, index)" />
            </svg>
          </span>
          <span style="width:25px;">{{scoreNum(score)}}</span>
    </div>
</template>

<script>
  export default {
    name: "Balls",
    props: ['score'],
    components: {
      ballsSummary: () => import('../components/BallsSummary')
    },
    data() {
      return {
      }
    },
    computed: {
      colors() {
        let result_colors = this.$store.getters['app/colors']
        let colors = {
          1: result_colors['red'],
          2: result_colors['lred'],
          3: result_colors['yellow'],
          4: result_colors['yellow'],
          5: result_colors['green'],
          6: result_colors['green'],
          7: result_colors['yellow'],
          8: result_colors['yellow'],
          9: result_colors['lred'],
          10:result_colors['red'],
          fill: result_colors.fill
        }
        return colors
      },
    },
    methods: {
      getFill(score, index) {
        let numScore = Math.round(score)
        if (numScore === index) {
          return this.colors[numScore]
        } else {
          return this.colors.fill
        }
      },
      scoreNum(score){
        if (score < 9.947) {
          return score.toFixed(1)
        } else {
          return 10
        }
      }
    }
  }
</script>